import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, UserCheck, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { Button, CHECKOUT_URL } from '../ui/Button';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/rMDE47mKX3dPeWQazKwAic/ChatGPT_Image_May_6,_2026,_01_01_17_AM.png';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-16 pb-20 md:pt-24 md:pb-28 overflow-hidden" data-id="element-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center px-3 py-1 rounded-full bg-white/10 text-white/80 text-xs font-bold tracking-wider uppercase mb-8 border border-white/10" data-id="element-22">
          TRIATLÓN EN 6HS — SISTEMA COMPLETO
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-10 max-w-4xl" data-id="element-23">
          Lográ preparar un 70.3 con 6 horas a la{' '}
          <span className="text-brand-green" data-id="element-24">semana</span>
        </motion.h1>

        <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="block w-full mb-10 cursor-pointer group" data-id="element-25">
          <img src={PRODUCT_IMAGE} alt="Triatlón en 6HS Product Bundle" className="w-[80%] max-w-2xl mx-auto h-auto object-contain drop-shadow-2xl transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-26" />
        </motion.a>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="font-serif italic text-xl md:text-2xl text-white/80 mb-8 max-w-3xl" data-id="element-27">
          Sistema de entrenamiento de triatlón diseñado para personas que NO
          viven para entrenar.
        </motion.p>

        <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-28">
          {[{
          icon: <FileText size={16} data-id="element-29" />,
          label: 'PDF digital'
        }, {
          icon: <Zap size={16} data-id="element-30" />,
          label: 'Acceso inmediato'
        }, {
          icon: <UserCheck size={16} data-id="element-31" />,
          label: 'Para principiantes'
        }].map(chip => <div key={chip.label} className="flex items-center gap-2 bg-white/5 px-4 py-2 rounded-full border border-white/10 text-sm font-medium text-white/90" data-id="element-32">
              <span className="text-brand-green" data-id="element-33">{chip.icon}</span>
              {chip.label}
            </div>)}
        </div>

        <Button href={CHECKOUT_URL} className="px-8 py-4 text-base md:text-lg mb-4" data-id="element-34">
          → QUIERO ENTRENAR TRIATLÓN SIN CAOS AHORA
        </Button>

        <div className="flex flex-wrap justify-center items-center gap-2 text-xs text-white/60 font-medium" data-id="element-35">
          <div className="flex items-center gap-1" data-id="element-36">
            <ShieldCheck size={14} className="text-brand-green" data-id="element-37" />
            Garantía 7 días
          </div>
          <span className="text-white/20" data-id="element-38">•</span>
          <div className="flex items-center gap-1" data-id="element-39">
            <Lock size={14} className="text-brand-green" data-id="element-40" />
            Pago 100% seguro
          </div>
          <span className="text-white/20" data-id="element-41">•</span>
          <div className="flex items-center gap-1" data-id="element-42">
            <CreditCard size={14} className="text-brand-green" data-id="element-43" />
            Mercado Pago | Tarjeta
          </div>
        </div>
      </div>
    </section>;
}